import type { Config } from "@jti/fe-common";
import { CasAuthApi } from "@jti/rest-api";
import { type IUser } from "@jti/rest-api-types";

export const checkLoggedIn = async (user: IUser, config?: Config): Promise<boolean> => {
  if (!user?.ciam_token) {
    return false;
  }

  try {
    const { statusCode } = await CasAuthApi.init(config ?? null).validate(user.ciam_token, true);
    return statusCode === 200 || statusCode === 204; // 200 - legacy, 204 - EVO
  } catch (e) {
    console.error("checkLoggedIn error ==>", e);
    return false;
  }
};
